import { MODULE_ID } from './constants';
export const SET_OTP = `${MODULE_ID}/SET_OTP`;
export const CLEAR_OTP = `${MODULE_ID}/CLEAR_OTP`;
export const SET_VERIFIED_SIGNATURE_TOKEN = `${MODULE_ID}/SET_VERIFIED_SIGNATURE_TOKEN`;
export const SET_AVAILABLE_COUNTRIES = `${MODULE_ID}/SET_AVAILABLE_COUNTRIES`;
export const SET_AVAILABLE_SCOPES = `${MODULE_ID}/SET_AVAILABLE_SCOPES`;
export const SET_IDENTITIES = `${MODULE_ID}/SET_IDENTITIES`;
export const SET_RESET_PASSWORD_IDENTITY = `${MODULE_ID}/SET_RESET_PASSWORD_IDENTITY`;
export const SET_LOADED_IDENTITY = `${MODULE_ID}/SET_LOADED_IDENTITY`;
export const UNSET_INACTIVE_IDENTITY = `${MODULE_ID}/UNSET_INACTIVE_IDENTITY`;
export const CHOOSE_COUNTRY = `${MODULE_ID}/CHOOSE_COUNTRY`;
export const CHOOSE_SCOPE = `${MODULE_ID}/CHOOSE_SCOPE`;
export const GO_TO_APP = `${MODULE_ID}/GO_TO_APP`;
export const GET_ME = `${MODULE_ID}/GET_ME`;
export const GET_ME_SUCCESS = `${MODULE_ID}/GET_ME_SUCCESS`;
export const GET_ME_ERROR = `${MODULE_ID}/GET_ME_ERROR`;
export const LIST_WALLET_ENTRIES = `${MODULE_ID}/LIST_WALLET_ENTRIES`;
export const LIST_WALLET_ENTRIES_SUCCESS = `${MODULE_ID}/LIST_WALLET_ENTRIES_SUCCESS`;
export const LIST_WALLET_ENTRIES_ERROR = `${MODULE_ID}/LIST_WALLET_ENTRIES_ERROR`;
export const SIGN_UP = `${MODULE_ID}/SIGN_UP`;
export const SIGN_UP_SUCCESS = `${MODULE_ID}/SIGN_UP_SUCCESS`;
export const SIGN_UP_ERROR = `${MODULE_ID}/SIGN_UP_ERROR`;
export const INIT_AUTH = `${MODULE_ID}/INIT_AUTH`;
export const SIGN_IN = `${MODULE_ID}/SIGN_IN`;
export const SIGN_IN_CANCEL = `${MODULE_ID}/SIGN_IN_CANCEL`;
export const SIGN_IN_SUCCESS = `${MODULE_ID}/SIGN_IN_SUCCESS`;
export const SIGN_IN_ERROR = `${MODULE_ID}/SIGN_IN_ERROR`;
export const RESEND_OTP = `${MODULE_ID}/RESEND_OTP`;
export const RESEND_OTP_SUCCESS = `${MODULE_ID}/RESEND_OTP_SUCCESS`;
export const RESEND_OTP_ERROR = `${MODULE_ID}/RESEND_OTP_ERROR`;
export const VERIFY_OTP = `${MODULE_ID}/VERIFY_OTP`;
export const VERIFY_OTP_SUCCESS = `${MODULE_ID}/VERIFY_OTP_SUCCESS`;
export const VERIFY_OTP_ERROR = `${MODULE_ID}/VERIFY_OTP_ERROR`;
// export const SIGN_IN_CALLBACK = `${MODULE_ID}/SIGN_IN_CALLBACK`;
// export const SIGN_IN_CALLBACK_SUCCESS = `${MODULE_ID}/SIGN_IN_CALLBACK_SUCCESS`;
// export const SIGN_IN_CALLBACK_ERROR = `${MODULE_ID}/SIGN_IN_CALLBACK_ERROR`;
export const SIGN_OUT = `${MODULE_ID}/SIGN_OUT`;
export const SIGN_OUT_SUCCESS = `${MODULE_ID}/SIGN_OUT_SUCCESS`;
export const SIGN_OUT_ERROR = `${MODULE_ID}/SIGN_OUT_ERROR`;
export const SIGN_OUT_CALLBACK = `${MODULE_ID}/SIGN_OUT_CALLBACK`;
export const SIGN_OUT_CALLBACK_SUCCESS = `${MODULE_ID}/SIGN_OUT_CALLBACK_SUCCESS`;
export const SIGN_OUT_CALLBACK_ERROR = `${MODULE_ID}/SIGN_OUT_CALLBACK_ERROR`;
export const FETCH_IDENTITY_PROVIDERS = `${MODULE_ID}/FETCH_IDENTITY_PROVIDERS`;
export const FETCH_IDENTITY_PROVIDERS_SUCCESS = `${MODULE_ID}/FETCH_IDENTITY_PROVIDERS_SUCCESS`;
export const FETCH_IDENTITY_PROVIDERS_ERROR = `${MODULE_ID}/FETCH_IDENTITY_PROVIDERS_ERROR`;
export const FETCH_IDENTITIES = `${MODULE_ID}/FETCH_IDENTITIES`;
export const FETCH_IDENTITIES_SUCCESS = `${MODULE_ID}/FETCH_IDENTITIES_SUCCESS`;
export const FETCH_IDENTITIES_ERROR = `${MODULE_ID}/FETCH_IDENTITIES_ERROR`;
export const SWITCH_IDENTITY = `${MODULE_ID}/SWITCH_IDENTITY`;
export const SWITCH_IDENTITY_SUCCESS = `${MODULE_ID}/SWITCH_IDENTITY_SUCCESS`;
export const SWITCH_IDENTITY_ERROR = `${MODULE_ID}/SWITCH_IDENTITY_ERROR`;
export const CONFIRM_EMAIL = `${MODULE_ID}/CONFIRM_EMAIL`;
export const CONFIRM_EMAIL_CANCEL = `${MODULE_ID}/CONFIRM_EMAIL_CANCEL`;
export const CONFIRM_EMAIL_SUCCESS = `${MODULE_ID}/CONFIRM_EMAIL_SUCCESS`;
export const CONFIRM_EMAIL_ERROR = `${MODULE_ID}/CONFIRM_EMAIL_ERROR`;
export const SET_CONFIRM_EMAIL_ACTIVATION_TYPE = `${MODULE_ID}/SET_CONFIRM_EMAIL_ACTIVATION_TYPE`;
export const UNSET_CONFIRM_EMAIL_ACTIVATION_TYPE = `${MODULE_ID}/UNSET_CONFIRM_EMAIL_ACTIVATION_TYPE`;
export const SEND_EMAIL_CONFIRM = `${MODULE_ID}/SEND_EMAIL_CONFIRM`;
export const SEND_EMAIL_CONFIRM_SUCCESS = `${MODULE_ID}/SEND_EMAIL_CONFIRM_SUCCESS`;
export const SEND_EMAIL_CONFIRM_ERROR = `${MODULE_ID}/SEND_EMAIL_CONFIRM_ERROR`;
export const CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN = `${MODULE_ID}/CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN`;
export const CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN_SUCCESS = `${MODULE_ID}/CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN_SUCCESS`;
export const CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN_ERROR = `${MODULE_ID}/CHECK_CONFIRM_TERMS_OF_SERVICES_BY_GUARDIAN_ERROR`;
export const UPDATE_ACCOUNT_SETTINGS = `${MODULE_ID}/UPDATE_ACCOUNT_SETTINGS`;
export const UPDATE_ACCOUNT_SETTINGS_SUCCESS = `${MODULE_ID}/UPDATE_ACCOUNT_SETTINGS_SUCCESS`;
export const UPDATE_ACCOUNT_SETTINGS_ERROR = `${MODULE_ID}/UPDATE_ACCOUNT_SETTINGS_ERROR`;
export const SET_INVITATION = `${MODULE_ID}/SET_INVITATION`;
export const SET_INVITATION_SUCCESS = `${MODULE_ID}/SET_INVITATION_SUCCESS`;
export const SET_INVITATION_ERROR = `${MODULE_ID}/SET_INVITATION_ERROR`;
export const ACCEPT_INVITATION = `${MODULE_ID}/ACCEPT_INVITATION`;
export const ACCEPT_INVITATION_WITH_NEW_PROFILE = `${MODULE_ID}/ACCEPT_INVITATION_WITH_NEW_PROFILE`;
export const ACCEPT_INVITATION_SUCCESS = `${MODULE_ID}/ACCEPT_INVITATION_SUCCESS`;
export const ACCEPT_INVITATION_ERROR = `${MODULE_ID}/ACCEPT_INVITATION_ERROR`;
export const REJECT_INVITATION = `${MODULE_ID}/REJECT_INVITATION`;
export const REJECT_INVITATION_SUCCESS = `${MODULE_ID}/REJECT_INVITATION_SUCCESS`;
export const REJECT_INVITATION_ERROR = `${MODULE_ID}/REJECT_INVITATION_ERROR`;
export const FETCH_INVITATION_INFORMATION_TEMPLATE = `${MODULE_ID}/FETCH_INVITATION_INFORMATION_TEMPLATE`;
// eslint-disable-next-line max-len
export const FETCH_INVITATION_INFORMATION_TEMPLATE_SUCCESS = `${MODULE_ID}/FETCH_INVITATION_INFORMATION_TEMPLATE_SUCCESS`;
export const FETCH_INVITATION_INFORMATION_TEMPLATE_ERROR = `${MODULE_ID}/FETCH_INVITATION_INFORMATION_TEMPLATE_ERROR`;
export const CHANGE_PASSWORD = `${MODULE_ID}/CHANGE_PASSWORD`;
export const CHANGE_PASSWORD_SUCCESS = `${MODULE_ID}/CHANGE_PASSWORD_SUCCESS`;
export const CHANGE_PASSWORD_ERROR = `${MODULE_ID}/CHANGE_PASSWORD_ERROR`;
export const RESET_PASSWORD = `${MODULE_ID}/RESET_PASSWORD`;
export const SET_RESET_PASSWORD_TYPE = `${MODULE_ID}/SET_RESET_PASSWORD_TYPE`;
export const RESET_PASSWORD_CANCEL = `${MODULE_ID}/RESET_PASSWORD_CANCEL`;
export const RESET_PASSWORD_SUCCESS = `${MODULE_ID}/RESET_PASSWORD_SUCCESS`;
export const RESET_PASSWORD_ERROR = `${MODULE_ID}/RESET_PASSWORD_ERROR`;
export const SET_PASSWORD = `${MODULE_ID}/SET_PASSWORD`;
export const SET_NEW_PASSWORD = `${MODULE_ID}/SET_NEW_PASSWORD`;
export const SET_NEW_PASSWORD_CANCEL = `${MODULE_ID}/SET_NEW_PASSWORD_CANCEL`;
export const SET_NEW_PASSWORD_SUCCESS = `${MODULE_ID}/SET_NEW_PASSWORD_SUCCESS`;
export const SET_NEW_PASSWORD_ERROR = `${MODULE_ID}/SET_NEW_PASSWORD_ERROR`;
export const SET_NEW_PASSWORD_CC = `${MODULE_ID}/SET_NEW_PASSWORD_CC`;
export const SET_NEW_PASSWORD_CC_SUCCESS = `${MODULE_ID}/SET_NEW_PASSWORD_CC_SUCCESS`;
export const SET_NEW_PASSWORD_CC_ERROR = `${MODULE_ID}/SET_NEW_PASSWORD_CC_ERROR`;
export const PASSPHRASE_RECOVERY = `${MODULE_ID}/PASSPHRASE_RECOVERY`;
export const PASSPHRASE_RECOVERY_SUCCESS = `${MODULE_ID}/PASSPHRASE_RECOVERY_SUCCESS`;
export const PASSPHRASE_RECOVERY_ERROR = `${MODULE_ID}/PASSPHRASE_RECOVERY_ERROR`;
export const SET_ELEVATED_PERMISSIONS_MODE = `${MODULE_ID}/SET_ELEVATED_PERMISSIONS_MODE`;
export const ELEVATE_PERMISSIONS = `${MODULE_ID}/ELEVATE_PERMISSIONS`;
export const ELEVATE_PERMISSIONS_SUCCESS = `${MODULE_ID}/ELEVATE_PERMISSIONS_SUCCESS`;
export const ELEVATE_PERMISSIONS_ERROR = `${MODULE_ID}/ELEVATE_PERMISSIONS_ERROR`;
export const ELEVATE_PERMISSIONS_TIMEOUT = `${MODULE_ID}/ELEVATE_PERMISSIONS_TIMEOUT`;
export const FETCH_ORGANIZATION_MEMBERSHIPS = `${MODULE_ID}/FETCH_ORGANIZATION_MEMBERSHIPS`;
export const FETCH_ORGANIZATION_MEMBERSHIPS_SUCCESS = `${MODULE_ID}/FETCH_ORGANIZATION_MEMBERSHIPS_SUCCESS`;
export const FETCH_ORGANIZATION_MEMBERSHIPS_ERROR = `${MODULE_ID}/FETCH_ORGANIZATION_MEMBERSHIPS_ERROR`;
export const APPROVE_ORGANIZATION_MEMBERSHIP = `${MODULE_ID}/APPROVE_ORGANIZATION_MEMBERSHIP`;
export const APPROVE_ORGANIZATION_MEMBERSHIP_SUCCESS = `${MODULE_ID}/APPROVE_ORGANIZATION_MEMBERSHIP_SUCCESS`;
export const APPROVE_ORGANIZATION_MEMBERSHIP_ERROR = `${MODULE_ID}/APPROVE_ORGANIZATION_MEMBERSHIP_ERROR`;
export const REJECT_ORGANIZATION_MEMBERSHIP = `${MODULE_ID}/REJECT_ORGANIZATION_MEMBERSHIP`;
export const REJECT_ORGANIZATION_MEMBERSHIP_SUCCESS = `${MODULE_ID}/REJECT_ORGANIZATION_MEMBERSHIP_SUCCESS`;
export const REJECT_ORGANIZATION_MEMBERSHIP_ERROR = `${MODULE_ID}/REJECT_ORGANIZATION_MEMBERSHIP_ERROR`;
export const TEST = `${MODULE_ID}/TEST`;
export const DELETE_ACCOUNT = `${MODULE_ID}/DELETE_ACCOUNT`;
export const DELETE_ACCOUNT_SUCCESS = `${MODULE_ID}/DELETE_ACCOUNT_SUCCESS`;
export const DELETE_ACCOUNT_ERROR = `${MODULE_ID}/DELETE_ACCOUNT_ERROR`;
export const EDIT_GUARDIAN_EMAIL = `${MODULE_ID}/EDIT_GUARDIAN_EMAIL`;
export const EDIT_GUARDIAN_EMAIL_SUCCESS = `${MODULE_ID}/EDIT_GUARDIAN_EMAIL_SUCCESS`;
export const EDIT_GUARDIAN_EMAIL_ERROR = `${MODULE_ID}/EDIT_GUARDIAN_EMAIL_ERROR`;
export const CLEAR_ERRORS = `${MODULE_ID}/CLEAR_ERRORS`;
